/**
 ** Creates a Stripe customer or retrieves an existing Stripe customer ID for a registered customer.
 * @async
 * @param {string} fullName - The full name of the customer.
 * @param {Object} customer - The customer object containing customer details.
 * @param {Function} updateCustomerMutation - The function to update customer information in the database.
 * @returns {string|null>} - It returns the Stripe customer ID or null if there was an error.
 * @throws {Error} If there's an error during the Stripe customer creation process.
 */

const getStripeCustomer = async (stripeAPI, fullName, customer, updateCustomerMutation) => {
    const {customerId, isRegistered, c_stripeCustomerID} = customer

    if (isRegistered && !c_stripeCustomerID) {
        try {
            const stripeCustomerID = await createStripeCustomerApiCall(
                stripeAPI,
                fullName,
                customer
            )
            if (stripeCustomerID) {
                updateCustomerMutation.mutate(
                    {
                        parameters: {customerId},
                        body: {c_stripeCustomerID: stripeCustomerID}
                    },
                    {
                        onSuccess: () => {
                            console.log('Stripe customer ID created', stripeCustomerID)
                        }
                    }
                )
                return stripeCustomerID
            }
        } catch (error) {
            console.error('Error while creating Stripe customer:', error)
        }
    } else if (isRegistered && c_stripeCustomerID) {
        console.log('Stripe customer ID exists:', c_stripeCustomerID)
        return c_stripeCustomerID
    } else {
        return await createStripeCustomerApiCall(stripeAPI, fullName, customer)
    }
}

const createStripeCustomerApiCall = async (stripeAPI, fullName, customer) => {
    try {
        const createStripeCustomerResult = await stripeAPI.customers.create({
            name: fullName,
            email: customer?.email
        })

        return createStripeCustomerResult?.id
    } catch (error) {
        console.error('Error in createStripeCustomerApiCall:', error)
        return null
    }
}

export default getStripeCustomer
